import React from 'react';
import { Button, Col, ContactFieldRow, EditableInfoComponent, Row } from 'components';
import { OutlineArrowDownIcon, OutlineArrowUpIcon, PhoneIcon } from 'components/common/icons';
import { ContactInfoEdit } from 'feature/clientTabs/general/contactInfo/edit';
import { useContactInfo } from 'feature/clientTabs/general/contactInfo/useContactInfo';
import { ContactInfoFieldKeyType } from 'typings/form';
import { useAccessControl } from 'components/common/accessControl/useAccessControl';
import { PERMISSIONS } from 'constants/permissions';

export const ContactInfo = () => {
  const { hasAccess } = useAccessControl();
  const {
    onModalStateChange,
    modalState,
    onShowAllStateChange,
    isAllShown,
    clientContactInfo,
    clientContactInfoList,
    isSeeAllVisible,
  } = useContactInfo();
  return (
    <>
      <EditableInfoComponent
        icon={<PhoneIcon />}
        editable={hasAccess(PERMISSIONS.clients.contact_info.write)}
        title={'Contact Info'}
        onEdite={onModalStateChange}
      />
      <Row gutter={[0, 4]} align={'middle'}>
        {Object.entries(clientContactInfo).map(([type, values]) => (
          <ContactFieldRow key={type} type={type as ContactInfoFieldKeyType} data={values as string[]} />
        ))}
        {isSeeAllVisible && (
          <Col span={24}>
            <Row align={'middle'} justify={'end'}>
              <Col>
                <Button
                  type={'link'}
                  variant={'link'}
                  style={{
                    color: '#308D82',
                    textDecoration: 'underline',
                    padding: 0,
                    margin: 0,
                    fontSize: 14,
                    fontWeight: 400,
                  }}
                  onClick={onShowAllStateChange}
                >
                  {isAllShown ? 'See Less' : 'See All'}
                  {isAllShown ? (
                    <OutlineArrowUpIcon size={'sm'} color={'#308D82'} />
                  ) : (
                    <OutlineArrowDownIcon size={'sm'} color={'#308D82'} />
                  )}
                </Button>
              </Col>
            </Row>
          </Col>
        )}
      </Row>
      <ContactInfoEdit
        modalState={modalState}
        onModalStateChange={onModalStateChange}
        dataToEdit={clientContactInfoList}
      />
    </>
  );
};
